import React from 'react';
import {
  EmailShareButton,
  EmailIcon,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
} from 'react-share';

const url = 'www.example.com';

const SocialShare = () => {
  return (
    <div className="Social-share">
      <LinkedinShareButton url={url}>
        <LinkedinIcon size={35} />
      </LinkedinShareButton>
      <TwitterShareButton url={url}>
        <TwitterIcon size={35} />
      </TwitterShareButton>
      <FacebookShareButton url={url}>
        <FacebookIcon size={35} />
      </FacebookShareButton>
      <WhatsappShareButton url={url} title="juan cantero">
        <WhatsappIcon size={35} />
      </WhatsappShareButton>
      <EmailShareButton
        url={url}
        style={{ display: 'none' }}
        body="tengo un programador para recomendarte"
        subject="trabajo"
      >
        <EmailIcon size={35} />
      </EmailShareButton>
    </div>
  );
};

export default SocialShare;
